<div class="report-row">
    <div class="flex-container report-row-header" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
        <div fxFlex="150px">
            <div>
                <app-report-row-icons [item]="item" fxFlex="180px"></app-report-row-icons>
            </div>
            <div style="width:150px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ item.getProperty('PrestataireDescription') }}</div>
            <div style="width:150px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ item.getProperty('DestinataireDescription') }}</div>
            <div style="width:150px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ item.getProperty('TemplateDescription') }}</div>
            <div style="width:150px;overflow-x: hidden;white-space:nowrap;font-size:75%;">{{ item.getProperty('ConsultationDate') }}</div>
        </div>
        <div fxFlex="grow">
            <div class="report-content" [innerHTML]="content  | crToBr | safeHtml"></div>
        </div>
    </div>
</div>